import useViewportSize from 'common/utilities/hooks/useViewportSize/useViewportSize';
import { enqueueWarningNotification } from 'core/redux/actions/notification/notificationActions';
import { useAppDispatch } from 'core/redux/store/configureStore';
import I18n from 'i18n/en-US';
import { useEffect, useRef } from 'react';

function BrowserZoomLevelWarning() {
  const dispatch = useAppDispatch();

  const size = useViewportSize();

  const warned = useRef(false);

  useEffect(() => {
    if (!warned.current && window.devicePixelRatio !== 1) {
      dispatch(enqueueWarningNotification(I18n.SequenceAnalyser.BrowserZoomLevelWarning.warning));
      warned.current = true;
    }
  }, [dispatch, size]);

  return null;
}

export default BrowserZoomLevelWarning;
